const DottedHalfRest = ({x, y, width, height}) => {
    return (
        <g fill="#000000">
            <rect x={x} y={y} width={width} height={height}/>
            <circle cx={x + width + 10} cy={y + 2} r={2} fill="#000000" strokeWidth={2}/>
        </g>
    )
}

export default DottedHalfRest